import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'eup-notification-card',
  templateUrl: './notification-card.component.html',
  styleUrl: './notification-card.component.scss'
})
export class NotificationCardComponent {
  constructor(private router: Router) {
  }

  onButtonClick() {
    this.router.navigate(['/doctors/orders']);
  }

}
